import { z } from 'zod'

export const SeedingStatusSchema = z.enum(['pending', 'running', 'seeded', 'failed'])

export const SeedingSchema = z.object({
  id: z.string(),
  tenantId: z.string(),
  dataset: z.string(),
  status: SeedingStatusSchema,
  attempts: z.number(),
  error: z.string(),
  startedAt: z.string().nullable(),
  finishedAt: z.string().nullable(),
})

export const SeedingListResponseSchema = z.object({
  count: z.number(),
  next: z.string().nullable(),
  previous: z.string().nullable(),
  results: z.array(SeedingSchema),
})
